import styled from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';

interface Props {
  isBold?: boolean;
}

export const Wrapper = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  margin: 20px 0 0;
  &:not(:last-child) {
    border-bottom: 1px solid ${COLORS.BLACK_BOLD};
  }
`;

Wrapper.displayName = 'Wrapper';

export const Channel = styled.div`
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 24px;
`;

Channel.displayName = 'Channel';

export const Box = styled.div`
  margin: 20px 0;
`;

Box.displayName = 'Box';

export const Day = styled.span`
  font-weight: 400;
  font-size: 14px;
`;

Day.displayName = 'Day';

export const Preview = styled.div``;

Preview.displayName = 'Preview';

export const Text = styled.span`
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.GRAY_TEXT};
  font-size: 13px;
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};
  display: inline-block;
  margin-bottom: 10px;
`;

Text.displayName = 'Text';

export const TextBox = styled.div`
  padding: 4px 9px;
  box-sizing: border-box;
  border: 1px solid #BBBBBB;
  color: #000000;
  text-align: justify;
  ${Text} {
    font-size: 12px;
  }
`;

TextBox.displayName = 'TextBox';

export const Summary = styled.div`
  margin: 0 auto;
  line-height: 20px;
`;

Summary.displayName = 'Summary';

export const SummaryTitle = styled.div`
  font-size: 13px;
  color: ${COLORS.BLACK_BOLD};
  font-family: ${FONTS.ROBOTO_BOLD};
`;

SummaryTitle.displayName = 'SummaryTitle';

export const SummaryDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  font-size: 15px;
  font-family: ${FONTS.ROBOTO};
`;

SummaryDescription.displayName = 'SummaryDescription';

export const TextDescription = styled.div`
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};
`;

TextDescription.displayName = 'TextDescription';

export const Line = styled.div`
  width: 100%;
  background-color: ${COLORS.GRAY_LIGHT};
  height: 1px;
  margin: 10px 0 16px;
`;

Line.displayName = 'Line';

export const TextHigh = styled.p`
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLUE_LINK};
  font-size: 16px;
  margin: 16px 0 10px;
`;